import { useEffect } from 'react'
import _get from 'lodash/get'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { URL_HOME, URL_ACCOUNT } from '../../services/url/constants'
import { handleRedirect } from './utils'

function GoRemoteLogin (props) {
  const {
    doConsumeRemoteLoginCode,
    location,
    history,
    user,
    auth,
  } = props

  const remoteLoginCode = _get(location, ['query', 'remoteLoginCode'])
  const redirectTo = _get(location, ['query', 'redirectTo'], null) || null

  const handleRemoteLogin = async () => {
    try {
      const { success } = await doConsumeRemoteLoginCode({ remoteLoginCode })
      const url = success ? redirectTo || URL_ACCOUNT : URL_HOME

      // redirect to the url
      handleRedirect({
        history,
        auth,
        user,
        url,
      })
    } catch (e) {
      // error, redirect to HP
      handleRedirect({
        history,
        auth,
        user,
        url: URL_HOME,
      })
    }
  }

  useEffect(() => {
    if (remoteLoginCode) {
      handleRemoteLogin()
    } else {
      handleRedirect({
        history,
        auth,
        user,
        url: URL_HOME,
      })
    }
  }, [])

  return null
}

GoRemoteLogin.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  doConsumeRemoteLoginCode: PropTypes.func.isRequired,
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  remoteLoginCode: state.remoteLoginCode || Map(),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    doConsumeRemoteLoginCode: actions.remoteLoginCode.doConsumeRemoteLoginCode,
  }
})(GoRemoteLogin)
